export enum Source {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}
